var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4L5 6.5L3 9.5C3.83333 11 5.7 14.2 6.5 15C7.5 16 10.5 14.5 11.5 14C12.3 13.6 14.5 10.8333 15.5 9.5L14 4H9.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM13.2604 7.124C13.5799 6.80448 13.5799 6.28643 13.2604 5.96691C12.9408 5.64739 12.4228 5.64739 12.1033 5.96691L7.77273 10.2975L5.89672 8.42146C5.5772 8.10194 5.05916 8.10194 4.73964 8.42146C4.42012 8.74098 4.42012 9.25902 4.73964 9.57854L7.19419 12.0331C7.5137 12.3526 8.03175 12.3526 8.35127 12.0331L13.2604 7.124Z",
    fill: "#9CF9CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsCheck);
export default __webpack_public_path__ + "static/media/terms-check.3a96ac4b6fadf68087a55fbaff1555ed.svg";
export { ForwardRef as ReactComponent };